<template>
  <div class="input">
    <input
      type="text"
      class="input__field"
      :class="classes"
      :placeholder="placeholder"
      :value="value"
      :required="required"
      @input="updateModel"
    >
  </div>
</template>

<script>
export default {
  name: 'BaseInputSearch',

  props: {
    value: String,
    required: Boolean,
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    variation: {
      type: String,
      default: ''
    }
  },

  computed: {
    classes () {
      return {
        'input__field--rounded': this.variation === 'rounded'
      }
    }
  },

  methods: {
    updateModel (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.input {
  &__field {
    @extend %input-text;

    padding-left: 40px;
    background: {
      image: url('~@/assets/img/main/icons/icon-search-component.svg');
      position: 15px 50%;
      repeat: no-repeat;
      size: auto 13px;
    }

    &--rounded {
      border-radius: 2em;
    }
  }
}
</style>
